import { render, staticRenderFns } from "./Attending.vue?vue&type=template&id=6b0ed52f&"
import script from "./Attending.vue?vue&type=script&lang=ts&"
export * from "./Attending.vue?vue&type=script&lang=ts&"
import style0 from "./Attending.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Attending.vue"
export default component.exports